// AgentVerse/common/schemas/collections/tasks.js
import { z } from "zod";

const CommentSchema = z.object({
    commentId: z.string().uuid().describe("Unique ID for the comment."),
    authorContactId: z.string().describe("MessagingContact ID of the author."),
    content: z.string().min(1, "Comment content cannot be empty."),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date().optional().nullable(),
});

const TaskSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    taskInstanceId: z.string().describe("Links this task to its TaskInstance container."),
    
    // Core Task Details
    title: z.string().min(1, "Task title is required."),
    description: z.string().optional().nullable(),
    type: z.enum(['task', 'bug', 'chore', 'initiative', 'epic', 'review', 'release']).optional().default('task'),
    owner: z.string().optional().nullable(),
    
    // Task Lifecycle & Categorization
    status: z.enum(['todo', 'in_progress', 'in_review', 'done', 'blocked']).default('todo'),
    priority: z.enum(['low', 'medium', 'high', 'urgent']).default('medium'),
    
    // Collaboration
    assignees: z.array(z.string()).optional().default([]).describe("Array of MessagingContact IDs assigned to this task."),
    claim: z.object({
        by: z.string(),
        userId: z.string().optional().nullable(),
        claimedAt: z.coerce.date().optional(),
        expiresAt: z.coerce.date().optional().nullable(),
    }).optional().nullable(),
    
    // Hierarchy
    parentId: z.string().optional().nullable().describe("The _id of the parent task, if this is a subtask."),
    depends_on: z.array(z.string()).optional().default([]).describe("Task IDs this task depends on."),
    
    // Scheduling & Timestamps
    dueDate: z.coerce.date().optional().nullable(),
    completedAt: z.coerce.date().optional().nullable(),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
    
    // Metadata & Comments
    tags: z.array(z.string()).optional().default([]),
    labels: z.array(z.string()).optional().default([]),
    milestones: z.array(z.string()).optional().default([]).describe("Milestone IDs linked to this task."),
    linked_files: z.array(z.string()).optional().default([]),
    comments: z.array(CommentSchema).optional().default([]),
    
    // State
    isArchived: z.boolean().default(false).describe("Whether this specific task is archived."),
});

export default TaskSchema;
export { CommentSchema };
